var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0454E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.375V19.625H16.042V8.375H18.625ZM11.958 8.375V19.625H9.375V8.375H11.958Z",
    stroke: "white",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/pause-button.2020a4e6a6d4f9f49b127f70dd9ae008.svg";
export { ForwardRef as ReactComponent };